module.exports = __webpack_public_path__ + "static/Irstrat2-0dc40aa32c11cd8b30eb5c5c4eb42e8d.png";